<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: huliekao
 * @Date: 2021-06-17 16:51:27
 * @LastEditors: Seven
 * @LastEditTime: 2021-07-06 12:06:42
-->
<template>
  <div style="position: relative" v-clickOut="hideDrap" :class="showhometree ? 'gogonghome' : 'gogong'">
    <!-- <Input v-model="select" @click.stop @on-focus="focus" clearable placeholder="请选择部门"></Input> -->
    <v-text-field
      v-model="select"
      :label="labelName"
      hide-details="auto"
      outlined
      placeholder="请选择部门"
      @mousedown="focus"
      :dense="true"
      :height="32"
      :clearable="true"
    ></v-text-field>
    <transition name="fade">
      <div
        v-show="IsShowTree"
        style="
          background-color: #fff;
          position: absolute;
          max-width: 400px;
          min-width: 174px;
          z-index: 111;
          border: 1px solid #eee;
          height: 350px;
          overflow-y: auto;
        "
      >
        <el-tree
          ref="dept"
          highlight-current
          default-expand-all
          :expand-on-click-node="false"
          :node-key="value"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :data="data"
          @current-change="currentChange"
        ></el-tree>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "DeptSys-Select",
  props: {
    name: null,
    // select: null,
    // 选择框默认文字
    showhometree: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    label: {
      type: String,
      default: "label"
    },
    value: {
      type: String,
      default: "value"
    },
    children: {
      type: String,
      default: "children"
    },
    // select和tree数据
    data: {
      type: Array,
    },
    labelName: {
      type: String,
    }
  },
  data() {
    return {
      select: "",
      IsShowTree: false,
      selectModel: null,
      // 数据的key value
      defaultProps: {
        children: this.children,
        label: this.label
      }
    };
  },
  directives: {
    clickOut: {
      bind: (el, binding) => {
        // removeEventListener只能移除对象上的某个具名函数
        function handler(e) {
          if (el.contains(e.target)) return false;
          binding.value();
        }
        el.handler = handler;
        document.addEventListener("click", el.handler);
      },
      unbind: function(el) {
        document.removeEventListener("click", el.handler);
      }
    }
  },
  computed: {
    ...mapGetters(["loginUser"]),
  },
  methods: {
    currentChange(val) {
      console.log('val触发了树',val);
      this.IsShowTree = false;
      this.select = val[this.label]
      this.$emit("update:select", val[this.value]);
      this.$emit("update:name", val[this.label]);
    },
    // 节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.label].indexOf(value) !== -1;
    },
    hideDrap() {
      this.IsShowTree = false;
    },
    focus() {
      this.IsShowTree = true;
    },
    init() {
      this.select = "";
    },
    // change(deptName) {
    //   if (deptName.target.value == "") {
    //     this.$emit("update:select", "");
    //     this.$emit("update:name", "");
    //   }
    //   var _that = this;
    //   this.data.list.forEach(element => {
    //     if (element.deptName === _that.select) {
    //       _that.nodeClick(element);
    //       this.$refs.dept.setCurrentKey(element.deptId);
    //     }
    //   });
    // },
    set(name) {
      this.select = name;
    },
    // 获取是否登陆进来是否是什么项目
    Gethometrack() {
      let type = this.loginUser.trackType
      switch (type) {
        case 0:
          // this.form.deptId = this.loginUser.deptId
          this.select = this.loginUser.deptName
          break;
        case 1:
          //  this.form.deptId = 2177
            this.select = '财经项目'
           break;
        case 2:
          // this.form.deptId = 1001
            this.select = '自考项目'
          break;
        case 3:
          // this.form.deptId = 2149
            this.select = '财会项目'
          break;
        case 4:
          // this.form.deptId = 2267
            this.select = '教师资格证项目'
          break;
        default:
          // this.form.deptId = this.loginUser.deptId
          this.select = this.loginUser.deptName
      }
      console.log('this.select', this.select);
    },
  },
  watch: {
    select (val, oldVal) {
      this.$refs.dept.filter(val);
      if (oldVal && !val) {
        this.$emit('update:select', '')
        this.$emit('update:name', '')
      }
    }
  },
  mounted() {
    this.Gethometrack()
    this.$nextTick(() => {
      // this.select = this.loginUser.deptName
      // 保证完全挂载
      // this.$refs.dept.setCurrentKey(this.select)
    });
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.gogonghome {
  padding-top: 4px;
}
::v-deep .v-input {
  background-color: #fff !important;
}
</style>

